import { useState } from 'react';

import {
  format,
  formatDistance,
  formatDistanceStrict,
  formatRelative,
} from 'date-fns';
import { es } from 'date-fns/locale';
import { ScrollView } from 'react-native';

function formatDateForDatetimeLocalInput(date: Date): string {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().substring(0, 16);
}

// Renders a list of 5-10 EtaPlayground components in a table format so we can play around with the ETA value.
export default function EtaTable() {
  return (
    <ScrollView>
      <h1>ETA using date-fns</h1>
      <a href='https://date-fns.org/docs/'>date-fns documentation</a>
      <br />
      <br />
      <br />
      <br />
      <table>
        <thead>
          <tr>
            <th>Time 'now'</th>
            <th>ETA</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 5 }).map((_, index) => (
            <tr key={index}>
              <EtaPlayground />
            </tr>
          ))}
        </tbody>
      </table>
    </ScrollView>
  );
}

// Renders a date time input field that when changed, updates the ETA value in human readable format.
function EtaPlayground() {
  const [timeNow, setTimeNow] = useState<string>(
    formatDateForDatetimeLocalInput(new Date())
  );
  // The ETA value is a date time string that is passed to the `Eta` component.
  const [eta, setEta] = useState<string>(
    formatDateForDatetimeLocalInput(new Date())
  );

  return (
    <>
      <td>
        <input
          type='datetime-local'
          value={timeNow}
          onChange={(e) => setTimeNow(e.target.value)}
        />
      </td>
      <td>
        <input
          type='datetime-local'
          value={eta}
          onChange={(e) => setEta(e.target.value)}
        />
      </td>
      <td>
        <Eta timeNow={timeNow} etaTime={eta} />
      </td>
    </>
  );
}

// Eta component that renders the ETA value in human readable format using date-fns.
function Eta({ timeNow, etaTime }: { timeNow: string; etaTime: string }) {
  return (
    <div>
      <p>"Now": {format(timeNow, 'yyyy-MM-dd HH:mm')}</p>
      <p>ETA: {format(etaTime, 'yyyy-MM-dd HH:mm')}</p>
      <p>
        Distance:{' '}
        {formatDistanceStrict(etaTime, timeNow, {
          locale: es,
        })}
        <br />
        ETA in words: {formatRelative(etaTime, timeNow, { locale: es })}
      </p>
    </div>
  );
}
